import { Create, Edit } from "@refinedev/mui";
import {Box, Grid, TextField} from "@mui/material";
import { useForm } from "@refinedev/react-hook-form";
import React, {useState} from "react";
import {Controller, FieldValues} from "react-hook-form";
import {BfARefineUtils} from "../../../utils/BfARefineUtils";
import {HttpError, useList, useTranslate} from "@refinedev/core";
import {IFile, ImageUploadComponent} from "../../../components/custom/ImageUploadComponent";
import {IBadge} from "../../../rest-data-provider/bfaTypes";

export const BadgeSave = () => {
    const {
        saveButtonProps,
        refineCore: { formLoading, onFinish, queryResult },
        register,
        control,
        formState: { errors },
        handleSubmit,
        setError

    } = useForm<IBadge>(
        {
            refineCoreProps: {
                onMutationError: (error, variables, context) => {
                    BfARefineUtils.extractServerSideErrors(error, setError);
                },
            },
        });
    const translate = useTranslate();

    const onFinishHandler = (data: FieldValues) => {
        var fileData = {};
        if(file && file.fileBase64 && file.filename) {
            fileData = {
                upload: {
                    fileName: file.filename,
                    fileBase64: file.fileBase64
                }
            }
        }
        onFinish({
            ...data,
            ...fileData
        });
    };

    const [file,setFile] = useState<IFile|null>(null);

    const formElements = (
        <Box
            component="form"
            sx={{ display: "flex", flexDirection: "column" }}
            autoComplete="off"
        >
            {queryResult?.data?.data.id && (
                <TextField
                    {...register("id", {})}
                    error={!!(errors as any)?.id}
                    className={'unimportant'}
                    helperText={(errors as any)?.id?.message}
                    margin="normal"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    label={translate('devices.fields.id')}
                    name="id"
                    disabled
                />
            )}

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        {...register("year", {})}
                        error={!!(errors as any)?.year}
                        helperText={(errors as any)?.year?.message}
                        margin="normal"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        type="text"
                        label={translate('badges.fields.year')}
                        name="year"
                    />
                </Grid>
                <Grid item xs={12}>
                    <Controller name={"upload"} control={control} render={({field, formState, fieldState}) =>
                        (
                            <ImageUploadComponent
                                didChangeImage={file1 => {
                                    setFile(file1);
                                }}
                                label={translate('badges.fields.image')} hasError={!!(formState.errors as any)?.upload} initialImageUrl={queryResult?.data?.data.image} errorText={(formState.errors as any)?.upload?.message}
                            />
                        )
                    } />
                </Grid>
            </Grid>
        </Box>
    )

    return (
        <>
            {queryResult?.data?.data.id && (
                <Edit isLoading={formLoading}  saveButtonProps={{onClick: handleSubmit(onFinishHandler) }}>
                    {formElements}
                </Edit>
            )}
            {!queryResult?.data?.data.id && (
                <Create isLoading={formLoading}  saveButtonProps={{onClick: handleSubmit(onFinishHandler) }}>
                    {formElements}
                </Create>
            )}
        </>
    );
};
